<template>
  <v-card class="pa-4" flat id="uploadCenter">
    <v-form v-if="formData != null">
      <v-row align="start">
        <v-col cols="12" xs="12" sm="10" md="8">
          <v-row>
            <v-col cols="6" class="py-0">
              <v-row>
                <v-col cols="12">
                  <span class="headline">Gerät</span>
                </v-col>
                <v-col cols="12">
                  <v-text-field label="Name" clearable outlined v-model="formData.name" dense></v-text-field>
                </v-col>
                <v-col cols="12">
                  <v-text-field
                      label="Stage-Name"
                      clearable
                      outlined
                      dense
                      persistent-hint
                      hint="Name, der im Stage-Portal angezeigt wird. Leer lassen, damit dort der Gerätename verwendet wird."
                      v-model="formData.stageName"
                  ></v-text-field>
                </v-col>
                <v-col cols="12" class="py-0" align="end">
                  <v-switch
                      v-model="formData.isService"
                      false-value="0"
                      true-value="1"
                      label="Service"
                  ></v-switch>
                </v-col>
              </v-row>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-row>
                <v-col>
                  <span class="headline">Standort Bild</span>
                </v-col>
              </v-row>
              <v-img :src="getBackgroundImageUrl(formData)" v-if="formData.imgBackground != 'none'"></v-img>
            </v-col>
          </v-row>

          <v-row>
            <v-col cols="6" class="py-9">
              <v-select
                  v-model="formData.tags"
                  :items="formData.tags"
                  outlined
                  chips
                  dense
                  value="fred"
                  deletable-chips
                  small-chips
                  label="Gruppe"
                  clearable
                  multiple
              ></v-select>
            </v-col>
            <v-col cols="6" class="py-9">
              <v-autocomplete
                  label="Gruppe"
                  :items="tagList"
                  clearable
                  outlined
                  dense
                  ref="acFields"
                  @keyup.enter.native="onEnterTag"
                  v-model="tagac"
              ></v-autocomplete>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" class="py-0">
              <v-text-field
                  label="Maximal Playlist Spiellänge"
                  outlined
                  dense
                  v-model="formData.maxDuration"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="12" xs="12" sm="6" class="py-0">
              <v-text-field
                  label="Netzwerk"
                  outlined
                  dense
                  v-model="cpName"
              ></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" class="py-0">
              <v-btn @click="showLinkCompany()" class="text-none" color="primary">zuweisen</v-btn>
            </v-col>
            <v-col cols="12" xs="12" sm="6" class="py-0">
              <v-text-field
                  label="Playlist"
                  outlined
                  dense
                  v-model="plName"></v-text-field>
            </v-col>
            <v-col cols="12" xs="12" sm="6" class="py-0">
              <v-btn @click="showLink()" class="text-none mr-4" disabled color="primary">zuweisen</v-btn>
              <v-btn @click="editPlaylist()" class="text-none" color="primary">bearbeiten</v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col cols="6" class="py-0">
              <v-select
                  outlined
                  dense
                  v-model="formData.deviceState"
                  :items="statusList"
                  item-text="title"
                  item-value="key"
                  label="Status"
              >
              </v-select>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-select
                  dense
                  outlined
                  v-model="formData.orientation"
                  :items="orientList"
                  item-text="title"
                  item-value="key"
                  label="Ausrichtung"
              >
              </v-select>
            </v-col>

            <v-col cols="6" class="py-0">
              <v-select
                  outlined
                  v-model="formData.setClientVersion"
                  :items="appsList"
                  item-text="name"
                  dense
                  item-value="name"
                  :label="'App Version' + formData.clientVersionString"
              >
              </v-select>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-text-field
                  label="Screen-Nr."
                  outlined
                  clearable
                  v-model="formData.screenNumber"
                  dense
              ></v-text-field>
            </v-col>
            <v-col cols="6" class="py-0">
              <v-select
                  dense
                  outlined
                  v-model="formData.workaround"
                  :items="workarounds"
                  item-text="title"
                  item-value="key"
                  label="Workround"
              >
              </v-select>
            </v-col>
          </v-row>

          <v-expansion-panels>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Display / Stele ({{formData.display}} / {{formData.displaySer}} / {{formData.stele}})
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="pa-4">
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="formData.display" label="Display Typ" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="formData.displaySer" label="Display Ser" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="formData.stele" label="Stele" clearable dense></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Player ({{formData.playerTyp}} / {{formData.playerMac}} / {{formData.playerSer}})
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row class="pa-4">
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="formData.playerTyp" label="Player Typ" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="formData.playerMac" label="Player Mac" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field v-model="formData.playerSer" label="Player Ser" clearable dense></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
            <v-expansion-panel>
              <v-expansion-panel-header>
                Netzwerk ({{formData.netip}} / {{formData.netsub}} / {{formData.netgateway}} / {{formData.proxy}})
              </v-expansion-panel-header>
              <v-expansion-panel-content>
                <v-row>
                  <v-col cols="6">
                    <v-text-field label="IP Adresse" v-model="formData.netip" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Sub Adresse" v-model="formData.netsub" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Gateway" v-model="formData.netgateway" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Proxy" v-model="formData.proxy" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="DNS1" v-model="formData.dns1" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="DNS2" v-model="formData.dns2" clearable dense></v-text-field>
                  </v-col>
                  <v-col cols="6">
                    <v-text-field label="Zugangsart" v-model="formData.inputType" clearable dense></v-text-field>
                  </v-col>
                </v-row>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>
          <v-row>
            <v-col cols="6">
              <v-btn @click="cancelItem()" class="text-none">Abbrechen</v-btn>
            </v-col>
            <v-col cols="6" class="text-right">
              <v-btn @click="updateItem()" color="primary" class="text-none">Speichern
              </v-btn>
            </v-col>


          </v-row>
        </v-col>
      </v-row>
    </v-form>

    <DialogLinkPlaylist ref="dlgLink" @save="onLink"></DialogLinkPlaylist>
    <DialogLinkCompany ref="dlgLinkCompany" @save="onLinkCompany"></DialogLinkCompany>


  </v-card>
</template>

<script>
import DialogLinkPlaylist from "../dialogs/DialogLinkPlaylist";
import DialogLinkCompany from "../dialogs/DialogLinkCompany";
import Vue from 'vue'
import tableUtils from "@/components/tables/TableUtils";

export default {
  name: 'TabDefault',
  components: {DialogLinkPlaylist, DialogLinkCompany,},
  methods: {
    onGetData: function (data) {
      data.tags = tableUtils.getTags(data)
      if (data.guidCompany) {
        Vue.prototype.$apiCompany.loadCompany(data.guidCompany, this.onGetCompany)
      }
      if (data.guidPlaylist) {
        Vue.prototype.$api.loadPlayList(data.guidPlaylist, this.onGetPlaylist)
      }
      this.formData = data
    },
    onItemUpdated: function (data) {
      console.log('onItemUpdated', data)
    },
    onEnterTag: function () {
      this.formData.tags.push(this.$refs.acFields.internalSearch)
    },
    cancelItem: function () {
      this.$router.push('/Dashboard/Netzwerke')
    },
    updateItem: function () {
      Vue.prototype.$api.updateDevice(this.deviceGuid, this.formData, this.onItemUpdated)
    },
    getLabelCompany: function () {
      if (this.company) {
        return 'Netzwerk gewählt ' + this.company.name
      }
      return 'Netzwerk zuweisen'
    },
    getBackgroundImageUrl: function (item) {
      var url = Vue.prototype.$config.HOST + '/media/devices/' + this.deviceGuid + '/' + item.imgBackground
      return url
    },
    editPlaylist: function () {
      console.log('showLink')
      this.$router.push('/Playlist/' + this.formData.guidPlaylist)
    },
    showLink: function () {
      console.log('showLink')
      this.$refs.dlgLink.open()
    },
    showLinkCompany: function () {
      console.log('showLink')
      this.$refs.dlgLinkCompany.open()
    },
    onLinkCompany: function (item) {
      console.log('onLinkCompany', item)
      Vue.prototype.$api.linkDeviceToCompany(this.deviceGuid, item, this.reload)
    },
    onLink: function (item) {
      console.log('onLink', item)
      Vue.prototype.$api.linkPlayListToDevice(item, this.deviceGuid, this.reload)
    },
    getLabelPlaylist: function () {
      if (this.playList) {
        return 'Playlist gewählt ' + this.playList.name
      }
      return 'Playlist zuweisen'
    },
    onUploadProgress: function (id, percent) {
      console.log(id, percent)
      Vue.prototype.$eventHub.$emit('OnProgress', percent)
      this.progress = percent
    },
    onUploadSuccess(data) {
      console.log('upload done', data)
      this.reload()
      Vue.prototype.$eventHub.$emit('OnProgress', 100)
    },
    onGetCompany: function (data) {
      this.company = data
      if (data) this.cpName = data.name
    },
    onGetPlaylist: function (data) {
      this.playList = data
      if (data) this.plName = data.name
    },
    onGetApps: function (data) {
      this.appsList = data
    },
    reload: function () {
      Vue.prototype.$api.loadDevice(this.deviceGuid, this.onGetData)
    }
  },
  props: ['device'],
  data() {
    return {
      uploadConfig: {
        uploadUrl: '',
        jQueryDivName: '#uploadCenter'
      },
      progress: 0,
      appsList: [],
      tab: null,
      tagList: [],
      companyId: 0,
      company: null,
      playList: null,
      formData: {
        name: '',
        stageName: '',
        screenNumber: '',
        owner: '',
        playlist: '',
        phone: '',
        create: '',
        orientation: '',
        changed: '',
        workaround: ''
      },
      tag: '',
      tagac: '',
      plName: '',
      cpName: '',
      deviceGuid: '',
      tags: [],
      workarounds: [
        {
          key: '',
          title: 'Kein'
        },
        {
          key: 'resizeVertical',
          title: 'Resize Bilder to 1080x1920'
        }
      ],
      orientList: [
        {
          key: 'vertical',
          title: 'Vertikal'
        },
        {
          key: 'horizontal',
          title: 'Horizontal'
        }
      ],
      statusList: [
        {
          key: 'NEW',
          title: 'Neu'
        },
        {
          key: 'ACTIVE',
          title: 'Aktiv'
        }
      ],

    }
  },
  mounted() {
    this.deviceGuid = this.$route.params.deviceGuid
    Vue.prototype.$api.loadApps(this.onGetApps)
    this.uploadConfig.uploadUrl = Vue.prototype.$config.HOST + '/v1/devices/upload/' + this.deviceGuid + '/background'
    this.uploadConfig.onUploadProgress = this.onUploadProgress
    this.uploadConfig.onUploadSuccess = this.onUploadSuccess
    Vue.prototype.$api.initDragAndDrop(this, this.uploadConfig, Vue.prototype.$eventHub)
    this.reload()

  }
}
</script>

<style scoped>

</style>
